// extracted by mini-css-extract-plugin
export default {"textGreen":"CQItzf5antsyFdHeO0Fu","textRed":"jThhd5hOGTnRgj_S_cAL"};